export default __webpack_public_path__ + "static/media/book_place_holder.0ed7fee5.svg";